interface Entry {
  id: string;
  guest_name: string;
  message: string | null;
  emoji: string | null;
  signature_data: string | null;
  photo_url: string | null;
  status: string;
  created_at: string;
}

interface Props {
  entries: Entry[];
}

export default function MessagesListTab({ entries }: Props) {
  const visible = entries.filter((e) => e.status === "visible");

  if (visible.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-20 text-center">
        <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-slate-100 text-slate-400 mb-3">
          <i className="ri-message-3-line text-3xl"></i>
        </div>
        <p className="text-slate-500 font-medium">Sin mensajes aún</p>
        <p className="text-slate-400 text-sm mt-1">
          Los mensajes de tus invitados aparecerán aquí
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <p className="text-sm text-slate-400 font-medium">
        {visible.length} {visible.length === 1 ? "mensaje" : "mensajes"} de invitados
      </p>
      {visible.map((entry) => (
        <div
          key={entry.id}
          className="bg-white rounded-2xl border border-slate-200 p-4"
        >
          <div className="flex items-start gap-3">
            {/* Thumbnail if photo */}
            {entry.photo_url && (
              <div className="w-14 h-14 rounded-xl overflow-hidden shrink-0 bg-slate-100 border border-slate-200">
                <img
                  src={entry.photo_url}
                  alt=""
                  className="w-full h-full object-cover object-top"
                />
              </div>
            )}

            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 flex-wrap mb-1">
                {entry.emoji && (
                  <span className="text-lg leading-none">{entry.emoji}</span>
                )}
                <span className="font-bold text-slate-800 text-sm">{entry.guest_name}</span>
                <span className="text-slate-300 text-xs ml-auto shrink-0">
                  {new Date(entry.created_at).toLocaleDateString("es-MX", {
                    day: "numeric",
                    month: "short",
                  })}
                </span>
              </div>
              {entry.message && (
                <p className="text-slate-600 text-sm leading-relaxed">
                  &ldquo;{entry.message}&rdquo;
                </p>
              )}
              {entry.signature_data && (
                <div className="mt-2 bg-slate-50 rounded-xl border border-slate-100 p-2">
                  <p className="text-[10px] text-slate-400 mb-1">Firma digital</p>
                  <img
                    src={entry.signature_data}
                    alt="firma"
                    className="h-10 object-contain"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}